export const Payment = {
	BACK: { key: 0, name: '戻る(選択なし)' }, // 戻る
	PAYPAL: { key: 1, name: 'PayPal' }, // PayPal
	CREDIT: { key: 2, name: 'クレジットカード' }, // クレジットカード
	DEFFER: { key: 3, name: '後払い' }, // 後払い
};
export type PaymentType = typeof Payment[keyof typeof Payment];

export const findPaymentByKey = (key: number): PaymentType => {
	return Object.values(Payment).find((p) => p.key === key) || Payment.PAYPAL;
};

export const findPaymentTypeValueByKey = (key: number) => {
	const payment = Object.values(Payment).find((p) => p.key === key);
	return payment ? payment.name : '';
};

export const isBack = (type: PaymentType) => {
	return Payment.BACK.key === type.key;
};
export const isPayPal = (type: PaymentType) => {
	return Payment.PAYPAL.key === type.key;
};
export const isCredit = (type: PaymentType) => {
	return Payment.CREDIT.key === type.key;
};
export const isDeffer = (type: PaymentType) => {
	return Payment.DEFFER.key === type.key;
};

// 注文区分
export const OrderTypeEntity = {
	PAYMENT: { key: 1 },
	PERIODIC_PAYMENT: { key: 2 },
};
export type OrderType = typeof OrderTypeEntity[keyof typeof OrderTypeEntity];

// 注文者区分
export const UserTypeEntity = {
	GAKKEN_ID: { key: 1 },
	GUEST: { key: 2 },
};
export type UserType = typeof UserTypeEntity[keyof typeof UserTypeEntity];

// ページ種別
export const Page = {
	DEFAULT: 0,
	SHOW_SAVED_CARD: 1,
	DELETE_CARD: 2,
	UN_SUPPORTED: 98,
	SERVICE_ERROR: 99,
};

// カード管理画面ページ種別
export type cardManagementPage = {
	DEFAULT_PAGE: number;
	CARD_INPUT_PAGE: number;
	CARD_DELETE_PAGE: number;
	CARD_DELETE_COMPLETE: number;
	CARD_INFO_PAGE: number;
	CARD_REGISTER_COMPLETE: number;
	CARD_UPDATE_COMPLETE: number;
	SUBSCRIPTION_INFO_PAGE: number;
	SUBSCRIPTION_CHANGE_PAGE: number;
	SUBSCRIPTION_SHOW_SAVED_CARD: number;
	SUBSCRIPTION_PAYMENT_UPDATE_COMPLETE: number;
	UN_SUPPORTED: number;
	SERVICE_ERROR: number;
};
